import { SuperAdminGalleryComponent } from './components/super-admin/super-admin-gallery/super-admin-gallery.component';
import { PaymentsComponent } from './components/payments/payments.component';
import { NewTeacherComponent } from './components/users/new-teacher/new-teacher.component';
import { AdminGuard } from './../../guards/admin.guard';
import { SessionComponent } from './components/courses/course/session/session.component';
import { CommentsComponent } from './components/comments/comments.component';
import { MaterialsComponent } from './components/materials/materials.component';
import { UsersComponent } from './components/users/users.component';
import { CourseInfoComponent } from './components/courses/course/info/info.component';
import { CourseComponent } from './components/courses/course/course.component';
import { AdminComponent } from './admin.component';
import { CoursesComponent } from './components/courses/courses.component';
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LessonComponent } from './components/courses/course/lesson/lesson.component';
import { UserComponent } from './components/users/user/user.component';
import { EnrollmentsComponent } from './components/enrollments/enrollments.component';
import { DrawingsComponent } from './components/drawings/drawings.component';
import { ReviewsComponent } from './components/reviews/reviews.component';
import { NewEnrollmentComponent } from './components/enrollments/new-enrollment/new-enrollment.component';
import { SuperAdminComponent } from './components/super-admin/super-admin.component';
import { SuperAdminGuard } from 'src/app/guards/super-admin.guard';
import { SuperAdminHomepageComponent } from './components/super-admin/super-admin-homepage/super-admin-homepage.component';
import { SuperAdminAdminsComponent } from './components/super-admin/super-admin-admins/super-admin-admins.component';
import { SuperAdminConfigsComponent } from './components/super-admin/super-admin-configs/super-admin-configs.component';
import { TransactionsComponent } from './components/transactions/transactions.component';
import { NewTransactionComponent } from './components/transactions/new-transaction/new-transaction.component';

const routes: Routes = [
  {
    path: 'admin',
    component: AdminComponent,
    canActivate: [AdminGuard],
    children: [
      {
        path: 'super-admin',
        component: SuperAdminComponent,
        canActivate: [SuperAdminGuard],
        canActivateChild: [SuperAdminGuard],
        children: [
          {
            path: 'homepage',
            component: SuperAdminHomepageComponent
          },
          {
            path: 'configs',
            component: SuperAdminConfigsComponent
          },
          {
            path: 'admins',
            component: SuperAdminAdminsComponent
          },
          {
            path: 'gallery',
            component: SuperAdminGalleryComponent
          },
          {
            path: '',
            redirectTo: 'homepage',
            pathMatch: 'full'
          }
        ]
      },
      {
        path: 'payments',
        component: PaymentsComponent
      },
      {
        path: 'transactions/new',
        component: NewTransactionComponent
      },
      {
        path: 'transactions',
        component: TransactionsComponent
      },
      {
        path: 'enrollments/new',
        component: NewEnrollmentComponent
      },
      {
        path: 'enrollments',
        component: EnrollmentsComponent
      },
      {
        path: 'courses/new',
        component: CourseInfoComponent
      },
      {
        path: 'courses/:courseid/lesson/:lessonid/session/:sessionid',
        component: SessionComponent
      },
      {
        path: 'courses/:courseid/lesson/:lessonid',
        component: LessonComponent
      },
      {
        path: 'courses/:courseid/edit',
        component: CourseInfoComponent
      },
      {
        path: 'courses/:courseid',
        component: CourseComponent
      },
      {
        path: 'courses',
        component: CoursesComponent
      },
      {
        path: 'materials',
        component: MaterialsComponent
      },
      {
        path: 'reviews',
        component: ReviewsComponent
      },
      {
        path: 'comments',
        component: CommentsComponent
      },
      {
        path: 'drawings',
        component: DrawingsComponent
      },
      {
        path: 'users/new-teacher',
        component: NewTeacherComponent
      },
      {
        path: 'users/:userid',
        component: UserComponent
      },
      {
        path: 'users',
        component: UsersComponent
      },
      {
        path: '',
        redirectTo: '/admin/courses',
        pathMatch: 'full'
      }
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class AdminRoutingModule { }
